import { animate, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { environment } from '@env/environment';

import {
  AnalyticsEvents,
  AnalyticsService,
  APP_CONFIG,
  EventsService,
  IAppConfig,
  StorageService,
  UserService,
} from '@app/core/services';

@Component({
  selector: 'app-trip-plan',
  templateUrl: './trip-plan.component.html',
  styleUrls: ['./trip-plan.component.scss'],
  animations: [
    trigger('addAnimate', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms ease-in', style({ opacity: 0, top: '20px' })),
      ]),
    ]),
  ],
})
export class TripPlanComponent implements OnInit, OnDestroy {
  @Input() wlMode = false;
  @Input() boxBtnMode = false;

  @Output() navigateClicked: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @ViewChild('tripButton') tripButton: ElementRef;

  originalSrc = environment.MEDIA_API_URL_ORIGINAL;
  showAddAnimateIcon = false;
  count = 0;

  private readonly isBrowser: boolean;

  private destroy$: Subject<void> = new Subject();

  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: IAppConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
    private eventsService: EventsService,
    private userService: UserService,
    private storageService: StorageService,
    private analyticsService: AnalyticsService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.updateProfile();
    this.eventsService.sendToTripSource$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value && value.id) {
          const bookmark_ids = this.storageService.BOOKMARK_IDS;

          if (bookmark_ids && bookmark_ids.includes(value.id)) {
            this.removeFromPlan(value.id);
          } else {
            if (this.isBrowser && window.screen.width > 768) {
              this.showAddAnimateIcon = true;
            }
            const user = this.storageService.USER;
            if (user) {
              this.userService.addBookmark(value.id).subscribe(() => {
                this.updateProfile();
              });
            } else {
              this.eventsService.setOpenLogin(true);
            }
          }
        }
      });
    this.eventsService.signInComplete$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value) {
          this.updateProfile(true);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  showTripPlanClick(): void {
    this.analyticsService.emitEvent(AnalyticsEvents.navigationTripPlans, {});
    this.navigateClicked.emit(true);
  }

  animationDone(): void {
    if (this.isBrowser && window.screen.width > 768) {
      this.showAddAnimateIcon = false;
      window.setTimeout(() => {
        this.tripButton.nativeElement.classList.toggle('animation-done');
      }, 300);
    }
  }

  checkCount(): boolean {
    // const profile = this.storageService.PROFILE;
    if (this.storageService.PLACE_IDS) {
      this.count = this.storageService.PLACE_IDS.length;
    }
    return true;
  }

  private removeFromPlan(id: number): void {
    const user = this.storageService.USER;
    if (user) {
      this.storageService.PLACE_IDS = this.storageService.PLACE_IDS.filter(
        item => item !== id,
      );
      this.userService.removeBookmark(id).subscribe(
        () => {
          this.updateProfile();
        },
        () => {
          this.storageService.PLACE_IDS.push(id);
        },
      );
    }
  }

  private updateProfile(withoutGetUser = false): void {
    if (this.storageService.USER) {
      let clusterId = null;

      if (this.appConfig.settings.is_white_label) {
        const cluster = this.storageService.SELECTED_CLUSTER;
        clusterId = cluster ? cluster.id : null;
      }

      this.userService.getBookmarks(clusterId).subscribe(response => {
        this.count = response.length;
        const ids = [];
        response.map(item => ids.push(item.id));
        this.storageService.BOOKMARK_IDS = ids;
        this.storageService.PLACE_IDS = ids;
      });
      if (!withoutGetUser) {
        this.userService.getUser().subscribe(response => {
          this.storageService.USER = response.user;
          this.storageService.PROFILE = response.profile;
        });
      }
    }
  }
}
